import { createEntityClient, runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { companyContract } from './companyContract';
import type { CompanyCreateModel, CompanyEditModel, CompanyModel } from './types/model';

/**
 * Companies of the selected project as served by the service worker. Changes
 * resolve once the server accepted them and reject with its error
 * (`ChannelRequestError.messageId`).
 */
export const companyClient = {
  ...createEntityClient(companyContract),

  /** Resolves with the saved company. */
  create(companyCreateModel: CompanyCreateModel): Promise<CompanyModel> {
    return runQueuedMutation(
      companyContract,
      'create',
      (uniqueId) => ({ companyCreateModel, uniqueId }),
      DomainMessagesTypes.createdEntity
    );
  },

  async edit(companyEditModel: CompanyEditModel): Promise<void> {
    await runQueuedMutation(
      companyContract,
      'edit',
      (uniqueId) => ({ companyEditModel, uniqueId }),
      DomainMessagesTypes.updatedEntity
    );
  },

  async remove(companyId: string): Promise<void> {
    await runQueuedMutation(
      companyContract,
      'remove',
      (uniqueId) => ({ companyId, uniqueId }),
      DomainMessagesTypes.deletedEntity
    );
  },

  async restore(companyId: string): Promise<void> {
    await runQueuedMutation(
      companyContract,
      'restore',
      (uniqueId) => ({ companyId, uniqueId }),
      DomainMessagesTypes.uploadedEntity
    );
  },
};
